export class ClassificationPolicySchedule {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "scheduleConfig",
            "baseName": "scheduleConfig",
            "type": "StandardBackupScheduleConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ClassificationPolicySchedule.attributeTypeMap;
    }
    constructor() {
    }
}
